import animation from './foundation/animation';
import { breakpoints, mediaQueries, mq, multipliers, viewportsArray } from './foundation/breakpoints';
import buttons from './foundation/buttons';
import colors from './foundation/colors';
import focus from './foundation/focus';
import fonts from './foundation/fonts';
import layout from './foundation/layout';
import radius from './foundation/radius';
import { spaces } from './foundation/spaces';
import typography from './foundation/typography';
import { expandVariants, normalizeStyles } from './utils';
export var theme = {
  animation: animation,
  breakpoints: breakpoints,
  buttons: buttons,
  colors: colors,
  disableScaling: false,
  expandVariants: expandVariants,
  focus: focus,
  fonts: fonts,
  layout: layout,
  mediaQueries: mediaQueries,
  mq: mq,
  multipliers: multipliers,
  normalizeStyles: normalizeStyles,
  radius: radius,
  spaces: spaces,
  typography: typography,
  viewportsArray: viewportsArray
};